export default "__VITE_ASSET__DMg9lKA5__"